import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Components/signup.css";
import { Footer } from "../Components/footer";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { DecodeStringFromAscii } from "../Components/datahide";
import { BASE_URL as api } from "../services";
import { LoadingSpinner } from "../Components/loading";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const Forgot = () => {
  const nav = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageValue = queryParams.get("id");
  const email = DecodeStringFromAscii(pageValue);
  

  const [password, setPassword] = useState("");
  const [conpass, setConpass] = useState("");
  const [newOTP, setNewOTP] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [cperrormsg, setcperrormsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const passwordRef = useRef(null);
  const conpassRef = useRef(null);
  const sendButtonRef = useRef(null);
  const verifyButtonRef = useRef(null);
  const updateButtonRef = useRef(null);

  useEffect(() => {
    if (email === "") {
      window.location.href = "/?page=true";
    }
    updateButtonRef.current.disabled = true;
    verifyButtonRef.current.disabled = true;
  }, [email]);

  const handlePassword = (event) => {
    const newPass = event.target.value;
    setPassword(newPass);
    validatePassword(newPass);
  };

  const handleConPassword = (event) => {
    const conPass = event.target.value;
    setConpass(conPass);
    if (password === conPass) {
      setcperrormsg("Password matched");
    } else {
      setcperrormsg("Password must be matched");
    }
  };

  const validatePassword = (password) => {
    const lowerCase = /[a-z]/g;
    const upperCase = /[A-Z]/g;
    const numbers = /[0-9]/g;
    if (!password.match(upperCase)) {
      setErrorMessage("Password should contain uppercase!");
    } else if (!password.match(lowerCase)) {
      setErrorMessage("Password should contain lowercase!");
    } else if (!password.match(numbers)) {
      setErrorMessage("Password should contain numbers!");
    } else if (password.length < 6) {
      setErrorMessage("Password length should be more than 6.");
    } else {
      setErrorMessage("");
    }
  };

  const Submit = async (e) => {
    e.preventDefault();
    try {
      if (password === conpass && password !== "") {
        const result = await axios.post(api + "/update", { email, password });
        if (result.data) {
          if (result.data === "no") {
            toast.info("Your password should not match with your old password");
          } else {
            toast.success("Your password updated successfully. Login with your new password");
          }
          nav("/", { replace: true });
        } else {
          toast.error("Something went wrong, try again");
        }
      } else {
        toast.error("Password must match the confirm password or enter a password");
      }
    } catch (error) {
      console.error(error);
      toast.error("No user found with that email address");
    }
  };

  const SendOTP = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(api + "/send-otp", { params: { email } });
      if (response.data.message === "OTP sent successfully") {
        toast.success("OTP sent to email successfully. Kindly review your Email's spam or bin folder for the OTP.");
        sendButtonRef.current.disabled = true;
        verifyButtonRef.current.disabled = false;
        setTimeout(() => {
          sendButtonRef.current.disabled = false;
        }, 30000);
      } else {
        toast.error(response.data.error);
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOTP = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(api + '/verify-otp', { email, otp: newOTP });
      if (response.data.message) {
        toast.success(response.data.message);
        updateButtonRef.current.disabled = false;
      } else {
        toast.error(response.data.error);
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = (ref) => {
    ref.current.type = ref.current.type === "password" ? "text" : "password";
  };

  return (
    <>
      <LoadingSpinner state={isLoading} />
      <div className="signup-body">
        <Navbar expand="lg" className="navbar navbar-expand-sm bg-dark navbar-dark">
          <Container>
            <Navbar.Brand href="/">
              <img alt="" src="./myport.png" width="40" height="30" className="d-inline-block align-top" />{" "}
              <i className="fa-solid">My Portfolio</i>
            </Navbar.Brand>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto"></Nav>
              <Nav></Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <section className="register-container">
          <div className="container signup-container">
            <div className="title">Forgot password reset it</div>
            <div className="content">
              <div className="form">
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Email</span>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      required
                      disabled
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Password</span>
                    <input
                      type="password"
                      ref={passwordRef}
                      placeholder="Enter your password"
                      value={password}
                      required
                      onChange={handlePassword}
                    />
                  </div>
                  <div className="d-flex justify-content-between w-100">
                    <div className="passvalidation">{errorMessage}</div>
                    <div className="form-check text-start">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        onClick={() => togglePasswordVisibility(passwordRef)}
                      />
                      <label className="form-check-label" htmlFor="flexCheckDefault">
                        Show Password
                      </label>
                    </div>
                  </div>
                  <div className="input-box">
                    <span className="details">Confirm Password</span>
                    <input
                      type="password"
                      ref={conpassRef}
                      placeholder="Confirm your password"
                      value={conpass}
                      required
                      onChange={handleConPassword}
                    />
                  </div>
                  <div className="d-flex justify-content-between w-100">
                    <div className={`passvalidation${password === conpass ? 'done' : ''}`}>{cperrormsg}</div>
                    <div className="form-check text-start">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        onClick={() => togglePasswordVisibility(conpassRef)}
                      />
                      <label className="form-check-label" htmlFor="flexCheckDefault">
                        Show Confirm Password
                      </label>
                    </div>
                  </div>
                  <div className="input-box">
                    <span className="details">OTP</span>
                    <input
                      type="password"
                      placeholder="Enter your otp"
                      required
                      onChange={(e) => setNewOTP(e.target.value)}
                    />
                    <small className="text-danger h5">
                      Note: Kindly review your Email's spam or bin folder for the OTP.
                    </small>
                  </div>
                </div>
                <div className="otp-button d-flex justify-content-around">
                  <button onClick={SendOTP} style={{ backgroundColor: "#007bff" }} ref={sendButtonRef} id="send">
                    Send OTP
                  </button>
                  <button onClick={verifyOTP} ref={verifyButtonRef} id="verify">
                    Verify OTP
                  </button>
                </div>
                <div className="sreg-button">
                  <button type="submit" id="reg" onClick={Submit} ref={updateButtonRef}>
                    Update
                  </button>
                </div>
                <div className="signup-link text-center">
                  I know my password ? <a href="/?page=true">Login</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <Footer />
        </section>
      </div>
    </>
  );
};
